module.exports = __webpack_public_path__ + "static/media/220-vietnam.98e8fea6.svg";